var map = {
	"./errorEmoji.svg": 78,
	"./heart.svg": 9105,
	"./iconClose.svg": 2131,
	"./iconDownCaret.svg": 2566,
	"./leftArrow.svg": 3731,
	"./newTab.svg": 5397,
	"./notification.svg": 6217,
	"./pause.svg": 7574,
	"./play.svg": 2051,
	"./search.svg": 3920,
	"./snowflake.svg": 8238,
	"./swipe.svg": 6640,
	"./tick.svg": 2836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1758;